import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '追番排行', href: '#ranking' },
  { label: '移动追番', href: '#app' },
  { label: '平台优势', href: '#features' },
  { label: '热门话题', href: '#topics' },
  { label: '联系我们', href: '#contact' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <a
            href="#hero"
            onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}
            className="flex items-center gap-2 no-underline group cursor-pointer"
          >
            <div className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-primary-500 flex items-center justify-center transition-transform duration-200 group-hover:scale-105">
              <i className="ri-movie-2-line text-background-50 text-lg md:text-xl" style={{ width: '1em', height: '1em' }}></i>
            </div>
            <span className="text-lg md:text-xl font-heading font-bold text-foreground-950 tracking-tight">
              6080<span className="text-primary-500">影视</span>
            </span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  item.label === '首页'
                    ? 'text-primary-500'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50'
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:block">
            <a
              href="#media"
              onClick={(e) => { e.preventDefault(); handleNavClick('#media'); }}
              className="inline-flex items-center gap-1.5 px-4 py-2 bg-primary-500 text-background-50 rounded-full text-sm font-semibold transition-all duration-200 hover:bg-primary-600 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line text-base" style={{ width: '1em', height: '1em' }}></i>
              开始追番
            </a>
          </div>

          {/* Mobile Hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`} style={{ width: '1em', height: '1em' }}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden fixed inset-0 top-16 bg-background-50 z-40 transition-all duration-300 ${
          mobileOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
      >
        <nav className="flex flex-col p-6 gap-2">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
              className={`px-4 py-3 rounded-xl text-base font-medium transition-colors duration-200 cursor-pointer ${
                item.label === '首页'
                  ? 'text-primary-500 bg-primary-50'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              {item.label}
            </a>
          ))}
          <a
            href="#media"
            onClick={(e) => { e.preventDefault(); handleNavClick('#media'); }}
            className="mt-4 px-4 py-3 bg-primary-500 text-background-50 rounded-xl text-base font-semibold text-center transition-colors hover:bg-primary-600 cursor-pointer"
          >
            开始追番
          </a>
        </nav>
      </div>
    </header>
  );
}